import { getToken } from '@/utils/auth'

import router from '@/router/index.js'
import useUserStore from '@/stores/User.js'
import { useSchoolStore } from '@/stores/School.js'
import { ElNotification } from 'element-plus'
import Config from '@/utils/Config.js'
const whiteList = [
  '/login',
  '/learnMall',
  '/error404',
  '/register',
]

export default function premission() {
  router.beforeEach((to, from, next) => {
    const UserStore = useUserStore()

    if (whiteList.indexOf(to.path) !== -1) {
      // 没有token
      // 在免登录白名单，直接进入
      next()
    } else if (to.meta.isWhiteList) {
      // 没有token
      // 在免登录白名单，直接进入
      next()
    } else if (getToken()) {
      /* has token*/
      if (to.path === '/login') {
        next({
          path: '/',
        })
      } else if (UserStore.UserRoles.length > 0) {
        // SPA 内跳转：若学校配置尚未拉取（如营销页整页跳转后），补拉 redeem 开关
        const schoolStore = useSchoolStore()
        if (!schoolStore.configLoaded) {
          schoolStore.fetchSchoolConfig().finally(() => next())
        } else {
          next()
        }
      } else {
        // 判断当前用户是否已拉取完user_info信息
        // 获取用户信息
        UserStore.GetUserInfo()
          .then(async res => {
            if (res.code === 200) {
              if (res.user?.userType === '01') {
                await UserStore.GetTeacherInfo(res)

                window.location.href = `${window.location.origin}${import.meta.env.VITE_APP_TEACHER}` + `#/home`

                return Promise.reject(res)
              } else if (res.user?.userType === '02') {
                const stuRes = await UserStore.GetStudentInfo(res)
                // 冷启动（刷新 / SSO / 营销页整页跳转）必须重拉学校配置，否则 redeem 按钮不显示
                await useSchoolStore().fetchSchoolConfig()

                const studentRoot = (import.meta.env.VITE_APP_STUDENT || '/').replace(/\/$/, '') || '/'
                const currentPath = window.location.pathname.replace(/\/$/, '') || '/'

                if (currentPath !== studentRoot) {
                  window.location = `${window.location.origin}${import.meta.env.VITE_APP_STUDENT}` + `#/home`
                }

                return stuRes
              }
              ElNotification.warning({
                title: 'Warning',
                message: 'User information not found',
              })
              setTimeout(() => {
                window.localStorage.removeItem('TOKEN')
                window.localStorage.removeItem(Config.tokenKey)
                window.localStorage.removeItem(Config.tokenTeacherKey)
                window.location.href = `${window.location.origin}${import.meta.env.VITE_APP_LOGIN}`
              }, 1000)
            }
          })
          .then(res => UserStore.GetReadHistoryList())
          .then(res => {
            // 拉取user_info后跳转
            next({
              ...to,
              replace: true,
            })
          })
          .catch(() => {
            UserStore.LogOut()
              .then(() => {
                next({
                  path: '/',
                })
              })
          })
      }
    } else {
      // 否则全部重定向到登录页
      const schStr = window.location.search

      /** @type {Record<string, string>} */
      const queryObj = {}

      if (schStr) {
        schStr.substr(1)?.split('&').forEach(str => {
          const arr = str.split('=')

          if (arr[0]) {
            queryObj[arr[0]] = arr[1]
          }
        })
      }
      if (queryObj.code) {
        const redirect = !queryObj.redirect ? `redirect=${encodeURIComponent(to.fullPath)}&` : ''

        window.location.href = `${window.location.origin}/marketing.html#/ebook?${redirect}${schStr.substr(1)}&bAuthon=Y`
      } else {
        window.location.href = `${window.location.origin}/marketing.html#/ebook`
      }
    }
  })

  router.afterEach(() => {

  })
}
